import { combineReducers } from 'redux';

import profile from './profile/profileReducer';
import { reducer as make } from './makeModule';

export default combineReducers({
	profile,
	make,
});
